enum TransactionsRequirements {
  Mismatch = "Mismatch",
  Allocated = "Allocated",
  Missing = "Missing",
  Overwritten = "Overwritten",
  Match = "Match",
  ViewReceipt = "View Receipts",
  ViewCategories = "View Categories",
  ViewAllocations = "View Allocations",
  ViewAttendees = "View Attendees",
  ViewMismatch = "View Mismatch",
  Exempt = "Exempt",
  Lost = "Lost",
  Approved_Lost = "Approved Lost",
}

export default TransactionsRequirements;
